export default __webpack_public_path__ + "static/media/stats.1ce6f11a.svg";